class AppMenuDirective {
    
    static factory (_, $, menu, $rootScope, $state, securityService, timer, helperService) {
       return {
            replace: true,
            restrict: 'A',
            templateUrl: 'app/menu/app-menu.html',
            compile: function compile( tElement, tAttributes, transcludeFn ) {
                let userRole = securityService.getAutheticatedUserRoles(); 
                let generateMenu = function(userRole, menu, isSub, menuDom, logoutItem) {
                    menuDom = menuDom + `<ul class=${isSub ? "sub-menu" : "site-navi__layout"} role=${isSub ? "menu" : "menubar"}  aria-hidden="false">`;
                    for (var option of menu) {
                        let classString = "";
                        if (option.sub) {
                            classString = classString + "class=has-subnav";
                            
                        }
                        let ngClassString = "";
                        if (option.state.indexOf("home") > 0) {
                            ngClassString = `ng-class="{'is-active': topIsActive('${option.state}')}"`;
                        }

                        if (helperService.hasValidRoleForAction(userRole, option)) {
                            menuDom = menuDom + `<li ${classString} ${ngClassString} role="menuitem" aria-haspopup="true">`;
                            let stateParts = option.state.split('.');
                            stateParts.shift();
                            let menuId = stateParts.join('');
                            let menuIdStr = option.sub ? `id=${menuId}` : '';
                            menuDom = menuDom + `<a ${menuIdStr} ui-sref="${option.state}" ui-sref-opts="{reload: true}" class="ng-binding">${option.text}</a>`;
                            if (option.sub) {
                                menuDom = generateMenu(userRole, option.sub, true, menuDom, option.logoutItem === true);
                            } else {
                                menuDom = menuDom + '</li>';
                            }
                            
                        }
                       
                    }
                    if (logoutItem) {
                        //For 'Log Out' option in 'Home Menu'
                        menuDom = menuDom + '<ul><li><a id="logoutDynamic" href="#" ng-click="logout($event)">Log out {{username}}</a></li></ul>';
                    }
                    return menuDom + '</ul>';
                   
                }

                $("#top").html(generateMenu(userRole, menu, false, "", false));
                return function postLink( scope, element, attributes, controller, transcludeFn ) {
                    
                    //This function is copied from menu-a11y.js it controls the top menu
                    //because its a jquery function to be run only when the directive DOM is fully generated
                    //the timer function adds an event to the angular queue which ensures that it is 
                    //only run after the DOM is fully generated.
                    timer(function() {
                        ! function(e) {
                            var t = {
                                48: "0",
                                49: "1",
                                50: "2",
                                51: "3",
                                52: "4",
                                53: "5",
                                54: "6",
                                55: "7",
                                56: "8",
                                57: "9",
                                59: ";",
                                65: "a",
                                66: "b",
                                67: "c",
                                68: "d",
                                69: "e",
                                70: "f",
                                71: "g",
                                72: "h",
                                73: "i",
                                74: "j",
                                75: "k",
                                76: "l",
                                77: "m",
                                78: "n",
                                79: "o",
                                80: "p",
                                81: "q",
                                82: "r",
                                83: "s",
                                84: "t",
                                85: "u",
                                86: "v",
                                87: "w",
                                88: "x",
                                89: "y",
                                90: "z",
                                96: "0",
                                97: "1",
                                98: "2",
                                99: "3",
                                100: "4",
                                101: "5",
                                102: "6",
                                103: "7",
                                104: "8",
                                105: "9"
                            };
                            e.fn.setup_navigation = function(a) {
                                a = jQuery.extend({
                                    menuHoverClass: "show-menu"
                                }, a), e(this).attr("role", "menubar").find("li").attr("role", "menuitem");
                                var n = e(this).find("> li > a"),
                                    i = e(this).find("> .has-subnav");
                                e(n).next("ul").attr("data-test", "true").attr({
                                    "aria-hidden": "true",
                                    role: "menu"
                                }).find("a").attr("tabIndex", -1), e(n).each(function() {
                                    e(this).next("div ul").length > 0 && e(this).parent("li").attr("aria-haspopup", "true")
                                }), e(n).hover(function() {
                                    e(this).closest("ul").attr("aria-hidden", "false").find("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1), e(this).next("ul").attr("aria-hidden", "false").addClass(a.menuHoverClass).find("a").attr("tabIndex", 0)
                                }, function() {
                                    e(this).next("ul").attr("aria-hidden", "false").find("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1)
                                }), e(".has-subnav").find("ul").hover(function() {}, function() {
                                    e(this).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1)
                                }), e(i).hover(function() {}, function() {
                                    e(this).find("ul").attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1)
                                }), e(n).focus(function() {
                                    e(this).closest("ul").find("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1), e(this).next("ul").attr("aria-hidden", "false").addClass(a.menuHoverClass).find("a").attr("tabIndex", 0)
                                }), e(n).keydown(function(n) {
                                    37 == n.keyCode ? (n.preventDefault(), 0 == e(this).parent("li").prev("li").length ? e(this).parents("ul").find("> li").last().find("a").first().focus() : e(this).parent("li").prev("li").find("a").first().focus()) : 38 == n.keyCode ? (n.preventDefault(), e(this).parent("li").find("ul").length > 0 && e(this).parent("li").find("ul").attr("aria-hidden", "false").addClass(a.menuHoverClass).find("a").attr("tabIndex", 0).last().focus()) : 39 == n.keyCode ? (n.preventDefault(), 0 == e(this).parent("li").next("li").length ? e(this).parents("ul").find("> li").first().find("a").first().focus() : e(this).parent("li").next("li").find("a").first().focus()) : 40 == n.keyCode ? (n.preventDefault(), e(this).parent("li").find("ul").length > 0 && e(this).parent("li").find("ul").attr("aria-hidden", "false").addClass(a.menuHoverClass).find("a").attr("tabIndex", 0).first().focus()) : 13 == n.keyCode || 32 == n.keyCode ? (n.preventDefault(), e(this).parent("li").find("ul[aria-hidden=true]").attr("aria-hidden", "false").addClass(a.menuHoverClass).find("a").attr("tabIndex", 0).first().focus()) : 27 == n.keyCode ? (n.preventDefault(), e("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1)) : e(this).parent("li").find("ul[aria-hidden=false] a").each(function() {
                                        return e(this).text().substring(0, 1).toLowerCase() == t[n.keyCode] ? (e(this).focus(), !1) : void 0
                                    })
                                });
                                var s = e(n).parent("li").find("ul").find("a");
                                e(s).keydown(function(n) {
                                    if (38 == n.keyCode) n.preventDefault(), 0 == e(this).parent("li").prev("li").length ? e(this).parents("ul").parents("li").find("a").first().focus() : e(this).parent("li").prev("li").find("a").first().focus();
                                    else if (40 == n.keyCode) n.preventDefault(), 0 == e(this).parent("li").next("li").length ? e(this).parents("ul").parents("li").find("a").first().focus() : e(this).parent("li").next("li").find("a").first().focus();
                                    else if (27 == n.keyCode || 37 == n.keyCode) n.preventDefault(), e(this).parents("ul").first().prev("a").focus().parents("ul").first().find("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1);
                                    else if (32 == n.keyCode) n.preventDefault(), window.location = e(this).attr("href");
                                    else {
                                        var i = !1;
                                        e(this).parent("li").nextAll("li").find("a").each(function() {
                                            return e(this).text().substring(0, 1).toLowerCase() == t[n.keyCode] ? (e(this).focus(), i = !0, !1) : void 0
                                        }), i || e(this).parent("li").prevAll("li").find("a").each(function() {
                                            return e(this).text().substring(0, 1).toLowerCase() == t[n.keyCode] ? (e(this).focus(), !1) : void 0
                                        })
                                    }
                                }), e(this).find("a").last().keydown(function(t) {
                                    9 == t.keyCode && e("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1);
                                }), e(document).click(function() {
                                    e("." + a.menuHoverClass).attr("aria-hidden", "true").removeClass(a.menuHoverClass).find("a").attr("tabIndex", -1);
                                }), e(this).click(function(e) {
                                    e.stopPropagation()
                                })
                            }
                        }($), $(function() {
                            $(".site-navi__layout").setup_navigation()
                        });
                    }, 0);
                    //end of jquery function        
                    
                };
            },
            controller: [
                '$', 'menuProvider', '$rootScope', '$scope', '$state', 'securityService', 
                function($, menu, $rootScope, $scope, $state, securityService) {
                  
                    $scope.topIsActive = function(state) {
                        return _.startsWith($state.current.name, _.replace(state, '.home', '')); 
                    }
                    //To Log out from 'Home Menu' 'Log Out' option
                    $scope.username = securityService.getAutheticatedUserId();
                    $scope.logout = function(event) {
                        event.preventDefault();
                        securityService.logout();
                        $state.go("auth.login");
                    };
                }]
        }
    }
}

AppMenuDirective.factory.$inject = ['_', '$', 'menuProvider', '$rootScope', '$state', 'securityService', '$timeout', 'helperService'];

export default AppMenuDirective;


// WEBPACK FOOTER //
// ./app/menu/app-menu.directive.js